import useApi from '../api';

export async function submitUpdatePlayerSubscription(data : any ){
  // To clean posted data
  const {put} = useApi();
  console.log({data});
  const itemId = data.id;
  const { responseBody } = await put('api/playersubscriptions/'+itemId, data, {isLogoutOnInvalidAuth: true});
  
  const responseData = responseBody;
  return responseData;
}